import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getNetworkDashboardSlice = createSelector(
  getPortalState,
  (state: any) => state.networkDashboard,
);

export const getInitialFilterSlice = createSelector(
  getNetworkDashboardSlice,
  (state: any) => state.initialFilters,
);

export const getInitialFiltersLoadedStatus = createSelector(
  getInitialFilterSlice,
  (state: any) => state.loaded,
);

export const getInitialFilters = createSelector(
  getInitialFilterSlice,
  (state: any) => state.data,
);

export const getTileDataSlice = createSelector(
  getNetworkDashboardSlice,
  (state: any) => state.tileData,
);

export const getTileDatasLoadedStatus = createSelector(
  getTileDataSlice,
  (state: any) => state.loaded,
);

export const getTileData = createSelector(
  getTileDataSlice,
  (state: any) => state.data,
);

export const getInitialParamsSlice = createSelector(
  getNetworkDashboardSlice,
  (state: any) => state.initialParamss,
);

export const getInitialParamssLoadedStatus = createSelector(
  getInitialParamsSlice,
  (state: any) => state.loaded,
);

export const getInitialParamss = createSelector(
  getInitialParamsSlice,
  (state: any) => state.data,
);
